import "../index.css";
import Hero from "../components/Hero";
import Features from "../components/Features";
import Agenda from "../components/Agenda";
import Campus from "../components/Campus";
import Pricing from "../components/Pricing";
import Loja from "../components/Loja";
import Tematica from "../components/Tematica";
import Header from "../components/Header";
import Hotel from "../components/HotelInfor";

function Home() {
  return (
    <>
      <Header></Header>
      <Hero></Hero>
      <Tematica></Tematica>
      <div id="tematica">
        {" "}
        <Features></Features>
      </div>{" "}
      <div id="sede">
        <Campus></Campus>
      </div>
      <div id="agenda">
        <Agenda></Agenda>
      </div>{" "}
      <div id="loja">
        <Loja> </Loja>
      </div>{" "}
          <div id="hotel">
        <Hotel></Hotel>
      </div>
      <div id="inscripcion">
        <Pricing></Pricing>{" "}
      </div>
  
    </>
  );
}

export default Home;
